import { IIdentityAbiClient } from './identity-api-client.interface';
import { Injectable } from '@angular/core';
import { IdentityApiClient } from './identity-api-client.service';
import { IdentityInMemoryApiClient } from './identity-in-memory-api-client.service';
import { environment } from '../../../../../../assets/environment/environment';
import { ApiClientProvider } from '../../../../core/data-access/http-client/clients/api-client-provider.service';

@Injectable({
    providedIn: 'root'
})
export class IdentityApiClientProvider extends ApiClientProvider<IIdentityAbiClient> {
    constructor(private identityApiClient: IdentityApiClient, private inMemoryApiClient: IdentityInMemoryApiClient) {
        super();
    }

    override getInMemoryClient(): IIdentityAbiClient {
        return this.identityApiClient;
    }
    override getApiClient(): IIdentityAbiClient {
        return this.identityApiClient;
    }
}
